module.exports = __webpack_public_path__ + "img/voto_h.2906e657.png";